import { useSlot } from '@pbk-web/ui';
import { createContext, useContext } from 'react';

import type { EditorSlot, LexicalProps } from '../../types';

const EditorPropsContext = createContext<LexicalProps | null>(null);

/** Makes the `PbkLexicalInput` props available to every plugin, so none of them take props. */
export const EditorPropsProvider = EditorPropsContext.Provider;

export const useEditorProps = (): LexicalProps => {
  const context = useContext(EditorPropsContext);

  if (!context) {
    throw new Error('useEditorProps must be used within an EditorPropsProvider');
  }

  return context;
};

/** A `PbkLexicalInput.Slot`'s content, as a render function (see `useSlot`). */
export const useEditorSlot = (name: EditorSlot) => useSlot(useEditorProps() as LexicalProps & { _slots: EditorSlot }, name);
